import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { Link, StaticQuery, graphql } from 'gatsby'
import Logo from '../../images/logo2.png';

// Styles
import '../../styles/app.css'

/**
* Main layout component
*
* The Layout component wraps around each page and template.
* It also provides the header, footer as well as the main
* styles, and meta data for each page.
*
*/
const DefaultLayout = ({ children, bodyClass, isHome }) => {

    const site = {
        "title": "Welcome to the Club",
        'subtitle': "Where chefs' secrets are shared ",
        // 'twitterUrl': 'https://twitter.com/flotiq',
        // 'facebookUrl': 'https://www.facebook.com/Flotiq-104200727751200/',
        // 'siteUrl': ''
    }

    useEffect(() => {
        // var link = document.createElement('meta');
        // link.setAttribute('property', 'og:image');

        // if(isHome){
        //     link.content = "https://chefscookery.club/static/hero-eb7ac781442d450772e4cf8c83858301.jpg"
        //     document.getElementsByTagName('head')[0].appendChild(link);
        // }else{
        //     document.querySelector('[property="og:image"]').remove()

        // }
    });

    return (
        <>
            <Helmet>
                <html lang="en" />
                <meta name="keywords" content="cooking, cookery, recipes, food, Indian food, Thai food, Chinese food, meals, cookery club, chefs' cookery club, meal recipes " />
                <meta name="author" content="Chefs' Cookery Club" />

                <script data-ad-client="ca-pub-6726141842650565" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
                <body className={bodyClass} />

                {/* <!-- Google Tag Manager --> */}
                <script type='text/javascript'>{`
                (function (w, d, s, l, i) {
                        w[l] = w[l] || [];
                        w[l].push({
                            "gtm.start": new Date().getTime(),
                            event: "gtm.js",
                        });
                        var f = d.getElementsByTagName(s)[0],
                            j = d.createElement(s),
                            dl = l != "dataLayer" ? "&l=" + l : "";
                        j.async = true;
                        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
                        f.parentNode.insertBefore(j, f);
                    })(window, document, "script", "dataLayer", "GTM-N77B4CC");
                `}

                </script>
                {/* <!-- End Google Tag Manager --> */}

            </Helmet>
            {/* <div id="fb-root"></div>
            <script async defer crossorigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v10.0" nonce="26G0VI7Z"></script>
            <div class="fb-like" data-href="https://chefscookery.club/" data-width="" data-layout="standard" data-action="like" data-size="large" data-share="true"></div> */}
            {/* <!-- Google Tag Manager (noscript) --> */}
            <noscript
            ><iframe
                src="https://www.googletagmanager.com/ns.html?id=GTM-N77B4CC"
                height="0"
                width="0"
                style={{ display: "none", visibility: "hidden" }}
            ></iframe
                ></noscript>
            {/* <!-- End Google Tag Manager (noscript) --> */}

            <div className="viewport">
                <div className="viewport-top">
                    {/* The main header section on top of the screen */}
                    <header className="site-head">
                        <div className="container">
                            <div className="site-mast">
                                <div className="site-mast-left">
                                    <Link to="/">
                                        <img className="site-logo" src={Logo} alt="Recipes with chefscookery.club" />
                                    </Link>
                                </div>
                                <div className="site-mast-right">
                                    {/* { site.twitterUrl && <a href={ site.twitterUrl } className="site-nav-item" target="_blank" rel="noopener noreferrer"><img className="site-nav-icon" src="/images/icons/twitter.svg" alt="Twitter" /></a>}
                                    { site.facebookUrl && <a href={ site.facebookUrl } className="site-nav-item" target="_blank" rel="noopener noreferrer"><img className="site-nav-icon" src="/images/icons/facebook.svg" alt="Facebook" /></a>}
                                    <a className="site-nav-item" href={ `https://feedly.com/i/subscription/feed/${site.siteUrl}/rss/` } target="_blank" rel="noopener noreferrer"><img className="site-nav-icon" src="/images/icons/rss.svg" alt="RSS Feed" /></a> */}
                                </div>
                            </div>
                            {isHome ?
                                <div className="site-banner">
                                    <h1 className="site-banner-title">{site.title}</h1>
                                    <p className="site-banner-desc">{site.subtitle}</p>
                                </div> :
                                null}
                            <nav className="site-nav">
                                <div className="site-nav-left">
                                </div>
                                <div className="site-nav-right">
                                    <Link className="site-nav-button" to="/about">About</Link>
                                </div>
                            </nav>
                        </div>
                    </header>

                    <main className="site-main">
                        {/* All the main content gets inserted here, index.js, post.js */}
                        {children}
                    </main>

                </div>

                <div className="viewport-bottom">
                    {/* The footer at the very bottom of the screen */}
                    <footer className="site-foot">
                        <div className="site-foot-nav container">
                            <div className="site-foot-nav-left">
                                <Link to="/">{site.title}</Link> © 2021
                            </div>
                            <div className="site-foot-nav-right">
                                <Link to="/privacyPolicy">Privacy Policy</Link>
                            </div>
                            {/* <div className="site-foot-nav-right">
                                <Link to="/sitemap">sitemap</Link>
                            </div> */}
                        </div>
                    </footer>

                </div>
                <button id="changePreferences" className="cookies">Cookies Preferences
               </button>
            </div>
             {/* <!-- Cookie Consent by https://www.FreePrivacyPolicy.com --> */}
             <script
                type="text/javascript"
                src="//www.freeprivacypolicy.com/public/cookie-consent/3.1.0/cookie-consent.js"
            ></script>
            <script type="text/javascript">{`
             document.addEventListener("DOMContentLoaded", function () {
                    cookieconsent.run({
                        notice_banner_type: "simple",
                        consent_type: "implied",
                        palette: "light",
                        language: "en",
                        website_name: "Chefs' Cookery Club",
                        change_preferences_selector: "#changePreferences",
                    });
                });
            `}
            </script>
            {/* <!-- End Cookie Consent --> */}

        </>
    )
}

DefaultLayout.propTypes = {
    children: PropTypes.node.isRequired,
    bodyClass: PropTypes.string,
    isHome: PropTypes.bool
}

const DefaultLayoutSettingsQuery = props => (
    <StaticQuery
        query={graphql`
            query GhostSettings {
                file(relativePath: {eq: "ghost-icon.png"}) {
                    childImageSharp {
                        fixed(width: 30, height: 30) {
                            ...GatsbyImageSharpFixed
                        }
                    }
                }
            }
        `}
        render={data => <DefaultLayout data={data} {...props} />}
    />
)

export default DefaultLayout
